import React from "react";

function BuildingLogo({ width = 49, height = 49 }) {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0589 36.8415L10.604 6.84645C10.6201 5.96255 10.9866 5.12122 11.623 4.50756C12.2594 3.8939 13.1135 3.55818 13.9974 3.57424L27.3285 3.81653C28.2124 3.83259 29.0537 4.19913 29.6674 4.83551C30.2811 5.47189 30.6168 6.32597 30.6007 7.20988L30.0556 37.2049L10.0589 36.8415Z"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3619 20.1778L7.02912 20.1172C6.14521 20.1011 5.29112 20.4369 4.65475 21.0505C4.01837 21.6642 3.65183 22.5055 3.63577 23.3894L3.45405 33.3878C3.43799 34.2717 3.77371 35.1258 4.38737 35.7621C5.00103 36.3985 5.84236 36.7651 6.72626 36.7811L10.059 36.8417"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.4493 15.543L33.7821 15.6035C34.666 15.6196 35.5073 15.9861 36.1209 16.6225C36.7346 17.2589 37.0703 18.113 37.0543 18.9969L36.7817 33.9944C36.7656 34.8783 36.3991 35.7196 35.7627 36.3333C35.1263 36.947 34.2722 37.2827 33.3883 37.2666L30.0556 37.2061"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.209 10.3008L23.8746 10.4219"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0879 16.9668L23.7535 17.0879"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9668 23.6328L23.6324 23.754"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8458 30.2988L23.5113 30.42"
        stroke="#1F2937"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default BuildingLogo;
